/**
 * Shared visual tokens for the home page (MCG design system values).
 */
export const homeColors = {
  ink: '#0B1B2B',
  navy: '#002E47',
  muted: '#637381',
  subtle: '#919EAB',
  border: '#E5E7EB',
  primary: '#015FFB',
  primaryDark: '#0151D5',
  success: '#29D25D',
  hover: '#F4F6F8',
  iconSurface: '#F1F4FA',
  badgeSurface: '#EEF1F5',
  badgeText: '#454F5B',
  barIdle: '#E3E8EF',
}

export const homeFont = "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif"

export const cardBase = {
  background: '#FFFFFF',
  border: `1px solid ${homeColors.border}`,
  borderRadius: '16px',
}

export const cardShadow =
  '0 12px 24px -4px rgba(145,158,171,.12), 0 0 2px rgba(145,158,171,.2)'

export const sectionLabel = {
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '.1em',
  textTransform: 'uppercase',
  color: homeColors.muted,
}

export const pageTitle = {
  margin: 0,
  fontSize: '36px',
  fontWeight: 800,
  letterSpacing: '-0.035em',
  lineHeight: 1.1,
  color: homeColors.ink,
}

export const linkButtonReset = {
  padding: 0,
  border: 0,
  background: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  textAlign: 'left',
}

/** Home page breakpoints: 4 → 2 columns below 900px, 1 column below 480px. */
export const media = {
  tablet: '@media (max-width: 899.98px)',
  phone: '@media (max-width: 479.98px)',
}
